export default {
  data () {
    return {
    }
  },
  computed: {
    externalLinksCommon () {
      return [
        // {
        //   icon: 'mdi-email',
        //   text: 'Send Email to Members',
        //   parms: [{parm: 'send_email', value: 1}]
        // }, /*
        //     {
        //       icon: 'mdi-message-settings-variant',
        //       text: 'Manage Member Prompt',
        //       parms: [{parm: 'manage_member_prompts', value: 1}]
        //     }, */
        // {
        //   icon: 'mdi-view-quilt',
        //   text: 'Edit Home Page',
        //   parms: [{parm: 'edit_announce', value: 1}]
        // },
        // {
        //   icon: 'mdi-file-pdf-box',
        //   text: 'Upload PDF',
        //   parms: [{parm: 'upload_pdf', value: 1}]
        // },
        // {
        //   icon: 'mdi-account-group',
        //   text: 'ForeTees Community',
        //   parms: [{parm: 'communityLogin', value: 1}]
        // }
      ]
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    /**
     * Called by Dialogs to check access for linking URLs in put request prompt callbacks
     * returning true allow doApiMessageLink to be called
     *
     * TODO:  Come up with better method for this
     */
    checkApiMessageLinkCommon (message, dialog) {
      switch (message.recordType) {
      case 'DiningBlocker':
        // User has access to manage blockers.  Allow linking to blockers
        return this.$ftAccess.manageBlockers
      case 'DiningEvent':
        // User has access to manage events or view reservations.  Allow linking to events
        return this.$ftAccess.viewReservations || this.$ftAccess.manageEvents
      case 'DiningMealPeriod':
        // User has access to manage manageMealPeriods or view reservations.  Allow linking to manageMealPeriods
        return this.$ftAccess.viewReservations || this.$ftAccess.manageMealPeriods
      case 'DiningReservation':
        // User has access to view reservations.  Allow linking to reservations
        return this.$ftAccess.viewReservations || this.$ftAccess.manageReservations
      }
      return false
    },
    /**
     * Called by Dialogs to generate App link URLs in put request prompt callbacks
     * Allows app te generate relative links to components based on ftAPI response data
     *
     * TODO:  Come up with better method for this
     */
    doApiMessageLinkCommon (message, dialog) {
      var routeData
      switch (message.recordType) {
      case 'DiningReservation':
        // Link to a list of dining reservations
        routeData = this.$router.resolve({path: '/reservations/upcoming', query: {sxp: 1, showId: message.ids[0], eoc: 1}})
        window.open(routeData.href, '_blank')
        break
      case 'DiningBlocker':
        // Link to a list of blockers
        routeData = this.$router.resolve({path: '/configuration/blockers', query: {sxp: 1, showId: message.ids[0], eoc: 1}})
        window.open(routeData.href, '_blank')
        break
      case 'DiningEvent':
        // Link to a list of events
        routeData = this.$router.resolve({path: '/events/upcoming', query: {sxp: 1, showId: message.ids[0], eoc: 1}})
        window.open(routeData.href, '_blank')
        break
      case 'DiningMealPeriod':
        // Link to a list of meal periods
        routeData = this.$router.resolve({path: '/configuration/meal-periods', query: {sxp: 1, showId: message.ids[0], eoc: 1}})
        window.open(routeData.href, '_blank')
        break
      }
    }
  }
}
